const ROOT_SELECTOR = '[data-onyx-advent]';
const BUTTON_SELECTOR = '.restock-rocket-preorder-button';
const TEMPLATE_SELECTOR = '[data-onyx-advent-preorder-template]';
const states = new WeakMap();

const normalizedText = (element) => String(element?.textContent || '').trim().replace(/\s+/g, ' ');
const providerContentCanBeEnhanced = (content) => /^secure your calendar!?$/i.test(normalizedText(content));

const buttonContentIsComplete = (content) => Boolean(
  content?.matches('[data-onyx-advent-preorder-content]')
  && content.querySelector('[data-onyx-advent-preorder-label]')
  && content.querySelector('[data-onyx-advent-preorder-price]')
  && content.querySelector('.onyx-advent__preorder-icon'),
);

const buildContent = (root) => [...document.querySelectorAll(TEMPLATE_SELECTOR)]
  .find((template) => template.dataset.onyxAdventPreorderTemplate === root.dataset.sectionId)
  ?.content.firstElementChild.cloneNode(true) || null;

const syncButton = (root, state) => {
  if (state.syncing) return;
  state.syncing = true;

  try {
    const button = root.querySelector(BUTTON_SELECTOR);
    const price = normalizedText(root.querySelector('[data-product-price]'));
    if (!button || !price) return;

    let content = button.querySelector('.button__content');
    if (!buttonContentIsComplete(content)) {
      if (!providerContentCanBeEnhanced(content)) return;
      const replacement = buildContent(root);
      if (!replacement || !content) return;
      content.replaceWith(replacement);
      content = replacement;
    }

    const priceTarget = content.querySelector('[data-onyx-advent-preorder-price]');
    if (priceTarget.textContent !== price) priceTarget.textContent = price;
    button.dataset.onyxAdventPreorderEnhanced = 'true';
  } finally {
    state.syncing = false;
  }
};

const scheduleSync = (root, state) => {
  if (state.frameId) return;
  state.frameId = window.requestAnimationFrame(() => {
    state.frameId = 0;
    syncButton(root, state);
  });
};

const initialize = (scope = document) => {
  const roots = scope.matches?.(ROOT_SELECTOR)
    ? [scope]
    : [...scope.querySelectorAll(ROOT_SELECTOR)];

  roots.forEach((root) => {
    if (states.has(root)) return;
    const state = { frameId: 0, observer: null, syncing: false };
    state.observer = new MutationObserver(() => scheduleSync(root, state));
    state.observer.observe(root, {
      attributes: true,
      attributeFilter: ['aria-busy', 'class', 'data-availability', 'disabled'],
      characterData: true,
      childList: true,
      subtree: true,
    });
    states.set(root, state);
    syncButton(root, state);
  });
};

const destroy = (scope) => {
  const roots = scope.matches?.(ROOT_SELECTOR)
    ? [scope]
    : [...scope.querySelectorAll(ROOT_SELECTOR)];

  roots.forEach((root) => {
    const state = states.get(root);
    if (!state) return;
    state.observer.disconnect();
    if (state.frameId) window.cancelAnimationFrame(state.frameId);
    states.delete(root);
  });
};

initialize();
document.addEventListener('restock-rocket:loaded', () => initialize());
document.addEventListener('shopify:section:load', (event) => initialize(event.target));
document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
